import React, { useState, useEffect } from 'react';
import { Box, Flex, Text, Button, IconButton, Separator, Spinner } from '@radix-ui/themes';
import { ChevronLeftIcon, ChevronRightIcon, MinusCircledIcon, PlusCircledIcon, TrashIcon, CheckIcon } from '@radix-ui/react-icons';
import { useSelector } from 'react-redux';
import { teachingPlanService } from '../../../services/teacher/teachingPlanService';

// select topics for content creation like quizzes, flashcards, etc.

const TopicsPicker = ({teachingPlan, selected, onComplete, onCancel}) => {

    const [lessons, setLessons] = useState([])
    const [browsing, setBrowsing] = useState({ lesson: 0 });
    const [selectedTopics, setSelectedTopics] = useState(selected || []);
    const [lastLesson, setLastLesson] = useState(0);
    const [initialLastLesson, setInitialLastLesson] = useState(0);
    const [loading, setLoading] = useState(false);

    const getPlanDetails = async () => {
        try {
            setLoading(true);
            const response = await teachingPlanService.getPlanDetails(teachingPlan.id);
            console.log('Plan details response:', response);
            setLessons(response.lessons);
            const lastLessonIndex = response.last_lesson_id ? response.lessons.findIndex(lesson => lesson.id === response.last_lesson_id) : 0;
            setInitialLastLesson(lastLessonIndex);
            setBrowsing({ lesson: lastLessonIndex });
        } catch (error) {
            console.error('Error fetching plan details:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getPlanDetails();
    }, []);

    const handleTopicSelect = async (topic) => {
        if (selectedTopics.length === 0) {
            setLastLesson(browsing.lesson);
        }

        const topics = selectedTopics.find(t => t.id === topic.id)
            ? selectedTopics.filter(t => t.id !== topic.id)
            : [...selectedTopics, topic];
        setSelectedTopics(topics);
        setLastLesson(browsing.lesson);

    };

    const handleSubmitTopics = () => {
        if (selectedTopics.length > 0) {
            onComplete({topics:selectedTopics, lastLessonId: lessons[lastLesson > initialLastLesson ? lastLesson : initialLastLesson].id});
        }
    }

    const renderTopic = (topic) => {
        const isSelected = selectedTopics.find(t => t.id === topic.id);
        return (
            <Flex
                direction="row"
                justify="start"
                align="center"
                key={topic.id}
                onClick={() => handleTopicSelect(topic)}
                className="simple-button"
                style={{
                    color: "white",
                    backgroundColor: isSelected ? 'var(--green-10)' : topic?.topic_completions?.length > 0 ? 'var(--gray-10)' : 'var(--accent-9)',
                    cursor: 'pointer'
                }}
            >
                {isSelected ? (
                    <MinusCircledIcon style={{ marginRight: '8px' }} />
                ) : (
                    <PlusCircledIcon style={{ marginRight: '8px' }} />
                )}
                <Text size="1">{topic.title}</Text>
            </Flex>
        )
    }

    if (loading) {
        return (
            <Flex direction="column" gap="4" align="center" minHeight="290px" justify="center">
                <Spinner size="large" />
                <Text size="1">Loading topics...</Text>
            </Flex>
        );
    }

  return (
    <Flex direction="column" gap="3">
        <Box>
            <Flex direction="row" gap="2" justify="between" align="start" mb="2">
                <Box>
                    <Flex direction="row" gap="2" align="start">
                        <Text className="small-round-badge">{browsing.lesson + 1}</Text>
                        <Flex direction="column" gap="1">
                            <Text size="2" weight="bold" mb="0" as="p">{lessons[browsing.lesson]?.title}</Text>
                            {/* <Text size="1" color="gray">{lessons[browsing.lesson]?.description}</Text> */}
                            <Text size="1" color="gray" as="p">Strand {lessons[browsing.lesson]?.strand?.order}: {lessons[browsing.lesson]?.strand?.title}</Text>
                    <Text size="1" color="gray" as="p">Sub-Strand {lessons[browsing.lesson]?.sub_strand?.order}: {lessons[browsing.lesson]?.sub_strand?.title}</Text>
                        </Flex>
                    </Flex>
                    {/* <Separator my="2" size="4" /> */}
                    
                </Box>
                <Box>
                    <Flex direction="row" justify="between" align="center" mb="2" gap="2">
                        <IconButton
                            variant="outline"
                            disabled={browsing.lesson === 0}
                            onClick={() => setBrowsing({
                                ...browsing,
                                lesson: browsing.lesson - 1
                            })}
                        >
                            <ChevronLeftIcon />
                        </IconButton>
                        <IconButton
                            variant="outline"
                            disabled={browsing.lesson === lessons.length - 1}
                            onClick={() => setBrowsing({
                                ...browsing,
                                lesson: browsing.lesson + 1
                            })}
                        >
                            <ChevronRightIcon />
                        </IconButton>
                    </Flex>
                </Box>
            </Flex>
        </Box>
        <Flex direction="column" gap="2" my="4">
            {lessons[browsing.lesson]?.topics?.map((topic) => (
                renderTopic(topic)
            ))}
        </Flex>
        <Flex direction="row" gap="2" justify="between" align="center">
            <IconButton size="1" onClick={() => setSelectedTopics([])}>
                <TrashIcon />
            </IconButton>
            <Flex gap="2">
                {/* <Button variant="solid" size="1" onClick={() => onCancel?.()}>Cancel</Button> */}
                <Button variant="solid" size="1" color="green" onClick={ handleSubmitTopics } disabled={selectedTopics.length === 0}><CheckIcon />Complete Selection</Button>
            </Flex>
        </Flex>
    </Flex>
  );
};

export default TopicsPicker;
